import "./messages.css";

import React, { Component } from "react";

import Api from "../services/api";
import AuthService from "../services/auth";
import USER_STATUSES from "../constants/userStatuses";
import UserChatEntry from "./UserChatEntry";
import { compose } from "recompose";
import { connect } from "react-redux";
import { db } from "../firebase";
import withAuthorization from "./withAuthorization";
//import close from '../static/vectors/close.svg';

class ChatConversations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
      unreadRooms: [],
      showUnread: false
    };
  }

  componentDidMount() {
    const { ucdUser } = this.props;
    const component = this;
    db.fixUserChatRooms(ucdUser.id);
    const roomRef = db.listUsersRoom(ucdUser.id);
    let hiddenRooms = [],
      userIds = [],
      users = {};
    roomRef
      .orderByChild("lastUpdated")
      .once("value")
      .then(snap => {
        snap.forEach(room => {
          userIds.push(...room.val().members);
        });
        userIds = userIds.splice(0, 25);
        new Api()
          .get(`/users`, { userIds }, AuthService.getAuthCookie())
          .then(response => {
            if (response) {
              response.map(user => {
                users[user.id] = user;
                return user;
              });
            }
            db.getHiddenRooms(ucdUser.id)
              .once("value")
              .then(snap => {
                let { rooms, unreadRooms } = this.state;
                if (snap.val() !== null) {
                  hiddenRooms = Object.values(snap.val());
                } else {
                  hiddenRooms = [];
                }

                db.userUnread(ucdUser.id)
                  .once("value")
                  .then(snap => {
                    if (snap.val() != null) {
                      Object.keys(snap.val()).forEach(roomKey => {
                        let messagesCount = 0;
                        db.getRoomMembers(roomKey).then(snap => {
                          let members = Object.keys(snap.val());
                          const member =
                            parseInt(members[0], 10) === ucdUser.id
                              ? parseInt(members[1], 10)
                              : parseInt(members[0], 10);
                          db.getRoomMessages(roomKey)
                            .once("value")
                            .then(snap => {
                              if (snap.val() !== null) {
                                messagesCount = Object.keys(snap.val()).length;
                              } else {
                                messagesCount = 0;
                              }
                              if (
                                !ucdUser.isBlockedBy.includes(member) &&
                                !hiddenRooms.includes(roomKey) &&
                                messagesCount > 0
                              ) {
                                if (userIds.includes(member)) {
                                  if (!!users[member]) {
                                    unreadRooms.push({
                                      user: users[member],
                                      id: roomKey,
                                      unread: true
                                    });
                                    this.setState({
                                      unreadRooms,
                                      loadCounter: 1
                                    });
                                  }
                                } else {
                                  new Api()
                                    .get(
                                      `/users`,
                                      { userId: member },
                                      AuthService.getAuthCookie()
                                    )
                                    .then(response => {
                                      response.id = member;
                                      unreadRooms.unshift({
                                        user: response,
                                        id: roomKey,
                                        unread: true
                                      });
                                      this.setState({ unreadRooms });
                                    })
                                    .catch(error => {
                                      console.error(error);
                                    });
                                }
                              }
                            });
                        });
                      });
                    }
                  });

                roomRef.orderByChild("lastUpdated").on("child_added", snap => {
                  const value = snap.val();
                  let members = value.members;
                  const roomKey = snap.key;
                  let messagesCount = 0;
                  db.getRoomMessages(roomKey)
                    .once("value")
                    .then(snap => {
                      if (snap.val() !== null) {
                        messagesCount = Object.keys(snap.val()).length;
                      }
                      db.userUnread(ucdUser.id)
                        .once("value")
                        .then(snap => {
                          let allRead = false,
                            roomRead = false;
                          if (snap.val() === null) {
                            allRead = true;
                          } else {
                            if (Object.keys(snap.val()).includes(roomKey)) {
                              roomRead = true;
                            }
                          }
                          if (
                            !ucdUser.isBlockedBy.includes(members[0]) &&
                            !hiddenRooms.includes(roomKey) &&
                            messagesCount > 0
                          ) {
                            if (userIds.includes(members[0])) {
                              if (!!users[members[0]]) {
                                rooms.push({
                                  user: users[members[0]],
                                  id: roomKey,
                                  unread: allRead ? false : roomRead
                                });
                                this.setState({ rooms, loadCounter: 1 });
                              }
                            } else {
                              /*(new Api()).get(`/users`, { userId: members }, AuthService.getAuthCookie())
                                  .then(response => {
                                    response.id = members[0];
                                    rooms.unshift({ user: response, id: roomKey });
                                    this.setState({rooms});
                                  });*/
                            }
                          }
                        });
                    });
                });

                roomRef.on("child_changed", snap => {
                  const roomKey = snap.key;
                  let { rooms } = component.state;
                  let isRoomListed = false;
                  rooms.map(el => {
                    if (el.id === roomKey) {
                      isRoomListed = true;
                    }
                    return el;
                  });
                  const value = snap.val();
                  if (
                    !ucdUser.isBlockedBy.includes(value.members[0]) &&
                    !hiddenRooms.includes(roomKey) &&
                    isRoomListed
                  ) {
                    let key = -1,
                      user;
                    for (let i in rooms) {
                      if (rooms[i].user.id === value.members[0]) {
                        key = i;
                        break;
                      }
                    }
                    user = rooms[key].user;
                    delete rooms[key];
                    rooms.unshift({ user, id: roomKey, unread: true });
                  } else if (
                    !ucdUser.isBlockedBy.includes(value.members[0]) &&
                    !hiddenRooms.includes(roomKey) &&
                    !isRoomListed
                  ) {
                    db.listUsersRoom(ucdUser.id)
                      .child(roomKey)
                      .once("value")
                      .then(snap => {
                        const value = snap.val();
                        const members = value.members;
                        new Api()
                          .get(
                            `/users`,
                            { userId: members },
                            AuthService.getAuthCookie()
                          )
                          .then(response => {
                            response.id = members[0];
                            rooms.unshift({
                              user: response,
                              id: roomKey,
                              unread: true
                            });
                            this.setState({ rooms });
                          });
                      });
                  }
                });
              });
          });
      });
  }

  loadMoreRooms() {
    let start = this.state.loadCounter;
    const { ucdUser } = this.props;
    const per_page = 25;
    const roomRef = db.listUsersRoom(ucdUser.id);
    let hiddenRooms = [],
      userIds = [],
      users = {};
    roomRef
      .orderByChild("lastUpdated")
      .once("value")
      .then(snap => {
        snap.forEach(room => {
          userIds.push(...room.val().members);
        });
        userIds = userIds.splice(start * per_page, per_page);
        new Api()
          .get(`/users`, { userIds }, AuthService.getAuthCookie())
          .then(response => {
            response.map(user => {
              users[user.id] = user;
              return user;
            });
            db.getHiddenRooms(ucdUser.id)
              .once("value")
              .then(snap => {
                let { rooms } = this.state;
                if (snap.val() !== null) {
                  hiddenRooms = Object.values(snap.val());
                } else {
                  hiddenRooms = [];
                }

                roomRef.orderByChild("lastUpdated").on("child_added", snap => {
                  const value = snap.val();
                  let members = value.members;
                  const roomKey = snap.key;
                  let messagesCount = 0;
                  db.getRoomMessages(roomKey)
                    .once("value")
                    .then(snap => {
                      if (snap.val() !== null) {
                        messagesCount = Object.keys(snap.val()).length;
                      }
                      db.userUnread(ucdUser.id)
                        .once("value")
                        .then(snap => {
                          let allRead = false,
                            roomRead = false;
                          if (snap.val() === null) {
                            allRead = true;
                          } else {
                            if (Object.keys(snap.val()).includes(roomKey)) {
                              roomRead = true;
                            }
                          }
                          if (
                            !ucdUser.isBlockedBy.includes(members[0]) &&
                            !hiddenRooms.includes(roomKey) &&
                            messagesCount > 0
                          ) {
                            if (userIds.includes(members[0])) {
                              if (!!users[members[0]]) {
                                rooms.push({
                                  user: users[members[0]],
                                  id: roomKey,
                                  unread: allRead ? false : roomRead
                                });
                                this.setState({
                                  rooms,
                                  loadCounter: start + 1
                                });
                              }
                            } else {
                              /*(new Api()).get(`/users`, { userId: members }, AuthService.getAuthCookie())
                            .then(response => {
                              response.id = members[0];
                              rooms.unshift({ user: response, id: roomKey });
                              this.setState({rooms});
                            });*/
                            }
                          }
                        });
                    });
                });
              });
          });
      });
  }

  deleteRoom(roomId, userId) {
    db.doDeleteRoom(userId, roomId);
    let { rooms } = this.state;
    rooms = rooms.filter(el => el.id !== roomId);
    this.setState({
      rooms
    });
  }

  render() {
    const { rooms, unreadRooms, showUnread } = this.state;
    const { onRoomSelected, onClose, ucdUser: user } = this.props;
    return (
      <div className="container-fluid chat-rooms">
        <div className="row header justify-content-end">
          <div className=" col col-12 text-right">
            <button
              className={`btn ${showUnread ? "active" : ""}`}
              onClick={() => {
                this.setState({ showUnread: true });
              }}
            >
              unread
            </button>
            <button
              className={`btn ${showUnread ? "" : "active"}`}
              onClick={() => {
                this.setState({ showUnread: false });
              }}
            >
              all messages
            </button>
            <button
              className="btn"
              onClick={() => {
                onClose();
              }}
            >
              close
            </button>
          </div>
        </div>
        {!showUnread && AuthService.isLoggedIn() && (
          <div className="row rooms">
            {rooms.map((room, i) => (
              <div key={i} className="col col-12">
                <UserChatEntry
                  user={room.user}
                  unread={room.unread}
                  disabled={user.status < USER_STATUSES.superior}
                  // eslint-disable-next-line
                  onClick={() => {
                    onRoomSelected(room.id, room.user);
                  }}
                  onDeleteRoom={() => {
                    this.deleteRoom(room.id, user.id);
                  }}
                />
              </div>
            ))}
          </div>
        )}
        {showUnread && AuthService.isLoggedIn() && (
          <div className="row rooms unread">
            {unreadRooms.map((room, i) => (
              <div key={i} className="col col-12">
                <UserChatEntry
                  user={room.user}
                  unread={room.unread}
                  disabled={user.status < USER_STATUSES.superior}
                  // eslint-disable-next-line
                  onClick={() => {
                    onRoomSelected(room.id, room.user);
                  }}
                  onDeleteRoom={() => {
                    this.deleteRoom(room.id, user.id);
                  }}
                />
              </div>
            ))}
          </div>
        )}
        <button
          className="btn load-more"
          onClick={() => {
            this.loadMoreRooms();
          }}
        >
          load more
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser
});

const mapDispatchToProps = dispatch => ({
  onClose: () =>
    dispatch({
      type: "SET_OPEN_DRAWER",
      openRoom: false,
      openChatDrawer: false
    })
});

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ChatConversations);



// WEBPACK FOOTER //
// ./src/components/chat-conversations.js